<!-- TODO: Add loader after adapter changes are done -->
<div class="card-carousel" *ngIf="content.cards">
  <div class="card-carousel--banner">
    <idp-banner [content]="content.cards[content.current - 1]"></idp-banner>
  </div>
  <div class="card-carousel--paginator" *ngIf="content.cards.length > 1">
    <idp-simple-paginator
      (current)="content.current = $event"
      [content]="content.paginator"
    ></idp-simple-paginator>
  </div>
</div>
